<template>
  <div>
    <div
      class="modal modal-right fade"
      id="modal_exceed_limit"
      role="dialog"
    >
      <div
        class="modal-dialog modal-lg bg-white"
        role="document"
      >
        <div
          class="modal-content"
          ref="section"
        >
          <div class="modal-header bg-dark">
            <h6 class="modal-title">
              <span>{{ $t("Usage Exceeds Plan Limits!") }}</span>
            </h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body pb-5 px-0 pt-0 ">
            <div v-show="isLoadExceedLimit">
              <div class="content">
                <placeholder-content is-load="true" />
              </div>
            </div>
           
            <div 
              class="card border-0 shadow-0"
              v-show="!isLoadExceedLimit"
            >
              <div v-if="hasPermission">
                <div class="px-3 py-2 border-bottom">
                  <h6 class="mb-0 font-weight-semibold">
                    <i class="fa-solid fa-circle-exclamation mr-2" />{{ $t('Plan Information') }}
                  </h6>
                </div>
                <div
                  class="alert alert-primary alert-dismissible text-primary mx-3 mt-3 mb-2 d-flex align-items-start"
                >
                  <div class="d-flex">
                    <span class="font-weight-bold mr-1">
                      <i class="fa-solid fa-circle-exclamation pr-1" />
                    </span>
                  </div>
                  <span>
                    <b>{{ $t("More Information:") }}</b>
                    {{ $t("Exceeds the maximum connection limit") }} {{ this.limitPage }} {{ $t("Channels for your plan. Please select an integration based on your plan limits to continue using it.") }}
                  </span>
                </div>
                <div class="mx-3 mt-0">
                  <p>
                    {{ $t('Connection Limit:') }} <span class="text-success">{{ limitPage }}</span> {{ $t('Channels') }}
                  </p>
                </div>
                <div class="row mx-3">
                  <div class="col-12 p-0">
                    <vuetable 
                      :no-data-template="$t('No Data Available')"
                      class="dataTable thead-bg-fafafa table-hover border-top border-left border-right border-bottom"
                      ref="vuetable"
                      :api-mode="false"
                      :fields="table.fields"
                      :data-manager="dataManager"
                      @vuetable:checkbox-toggled-all="toggleAllCheckboxes"
                      @vuetable:checkbox-toggled="toggleCheckboxs"
                    >
                      <div
                        slot="status"
                        slot-scope="props"
                      >
                        <span
                          v-if="props.rowData.is_connected"
                          class="ml-2 badge bg-success-400 p-1"
                        >
                          <i class="fas fa-check-circle mr-1" />
                          {{ $t("Connected") }}
                        </span>
                        <span
                          v-else
                          class="ml-2 badge bg-warning-400 p-1"
                        >
                          <i class="fa-solid fa-circle-xmark mr-1" />
                          {{ $t("Disconnect") }}
                        </span>
                      </div>
                      <div
                        slot="image"
                        slot-scope="props"
                      >
                        <img
                          v-if="$storeIndex.isset(() => props.rowData.items[0].images[0])"
                          :src="props.rowData.logo"
                          class="pointer image_box"
                        >
                        <img
                          v-else
                          :src="$storeIndex.getImageGobalAssets(props.rowData.id)"
                          class="image_box"
                        >
                      </div>
                    </vuetable>
                  </div>
                </div>
              </div>
              <div v-else>
                <accessDenied />
              </div>
            </div>
          </div>
          <div 
            class="py-2 modal-footer fixed-bottom bg-light border-bottom justify-content-center" 
            v-if="hasPermission"
          >
            <button
              type="button"
              class="btn btn-primary ml-2 mr-2"
              @click="selectIntegration"
              :disabled="isDisabled"
            >
              <i class="fa-solid fa-circle-check mr-2" />
              {{ $t("Confirm") }}
            </button>
            <button
              type="button"
              class="ml-2 mr-2 btn btn-light"
              data-dismiss="modal"
              @click="closeModal"
            >
              {{ $t("Cancel") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import Api from '@/services/endpoint/tenant.service';
import PlaceholderContent from '@/plugins/PlaceholderContent.vue'
import Ladda from '@/plugins/Ladda.vue'
import Vuetable from 'vuetable-2'
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import fields from "./assets/pageListFields.js";
export default {
  components: {
    PlaceholderContent,
    AccessDenied,
    Vuetable
  },
  data() {
    return {
      data: [],
      isLoadExceedLimit: true,
      pageList: [],
      limitPage: 0,
      perPage: 99,
      checkedCount: 0,
      hasPermission: false,
      pageSelect:[],
      isCheckAll: false,
      select:[],
      loading: "",
      table: {
        fields: fields,
        sortOrder: [
          {
            field: "created_date",
            direction: "desc",
          },
        ],
      },
      vuetableFields: false,
      isDisabled: false
    }
  },
  methods: {
    dataManager(sortOrder, pagination) {
      if (this.data.length < 1) return;

      let local = this.data;
  
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }
      this.$refs.vuetable.selectedTo = local.map(function(data){
        if(data.is_connected){
          return data.id;
        }
      });

      this.select =  local.map(function(data){
        if(data.is_connected){
          return data.id;
        }
      });

      pagination = this.$refs.vuetable.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;

      return {
        pagination: pagination,
        data: _.slice(local, from, to)
      };
    },
    vuetableLoaded() {
      this.loading = "";
    },
    vuetableLoading() {
      this.loading = "loading";
    },
    clearSelected() {
      this.checkedCount = 0;
      this.selectedBulk = this.$refs.vuetable.selectedTo = [];
    },
    onInitialized(fields) {
      this.vuetableFields = fields.filter((field) => field.togglable);
    },
    toggleAllCheckboxes(event, dataItem) {
      var selectedTo = [];
      this.$refs.vuetable.selectedTo.forEach((value) => {
        // filter data table cancel status
        const filterDataId = this.$refs.vuetable.tableData.filter(
          function (row) {
            return true;
          }
        );
        if (typeof filterDataId[0] != "undefined") {
          selectedTo.push(filterDataId[0].id);
        }
      });

      this.checkedCount = event
        ? this.$refs.vuetable.selectedTo.length
        : 0;
      this.setSelectBulk(this.$refs.vuetable);
    },
    toggleCheckboxs(event) {
      this.checkedCount = event ? this.checkedCount + 1 : this.checkedCount - 1;
      this.setSelectBulk(this.$refs.vuetable);
    },
    setSelectBulk(vuetable) {
      let self = this;
      let dataSelect = [];
      self.selectedBulk = vuetable.selectedTo;
      vuetable.tableData.map((item, index) => {
        if (vuetable.selectedTo.includes(item.id)) {
          dataSelect.push(item.id);
        }
        // if (vuetable.tableData.length == (index+1)) {
        //   self.$refs.bulkAction.setBulkAction(dataSelect, self.selectedBulk);
        // }
      });
      this.select = dataSelect;
    },
    getIntegration: async function () {
      // this.$parent.isShowPagemodal = false;
      try {
        const pageList = await Api.Integration.getAllSocialConnected();
        // this.data = pageList.data.data;
        pageList.data.data.forEach((value) => {
          this.data.push({
            id: value.gochat._id,
            name: value.name,
            logo: value.logo,
            status: value.status,
            sum_sale_order: value.sum_sale_order,
            group: value.group,
            is_connected: value.gochat.is_connected,
          });
        }); 

        this.limitPage = pageList.data.limit_feature.connect_social_media;
        this.isLoadExceedLimit = false;
        this.hasPermission = true;
        
        return true;
      } catch (error) {
        console.log('error', error);
        if (error.response.status === 403) {
          this.hasPermission = false;
          this.isLoadExceedLimit = false;
          
        }
      }
    },
    selectIntegration: async function(){

      const res = this.select.filter(element => {
        return element !== null && element !== undefined;
      });

    
      let param = {
        "page_ids": res,
      }

      if(this.select.length <= 0 ){
        return false;
      }
      this.$swal({
        icon: "warning",
        iconColor: "#FF7043",
        title: this.$t("Are you sure?"),
        html: this.$t("Unselected sales channels are automatically deleted from the integration on your store."),
        showCancelButton: true,
        cancelButtonText: this.$t("Cancel"),
        confirmButtonText: '<i class="mr-1 fas fa-check-circle"></i>' + this.$t("Confirm"),
        buttonsStyling: false,
        customClass: {
            confirmButton: "btn btn-primary mr-2",
            cancelButton: "btn btn-light",
        },
        focusConfirm: false,
      }).then(async (result) => {
          if (result.isConfirmed) {
            this.isDisabled = true;

            try {
              const addPage = await Api.Integration.addMultiSocialChannel(param);
              if(addPage.data.status){
                const exeedLimit = await Api.PlanSubscription.getExceedLimit();
                this.$store.dispatch(
                  "user/showExceed",
                  exeedLimit.data.data
                );

                this.$toastr.s(
                  this.$t("Update Integration Success!!"),
                  "<span class='t-icon icon-checkmark3'></span>" + this.$t("Success")
                );

                setTimeout(function(){
                  $("#modal_exceed_limit").modal('hide');
                }, 1000);

                if(this.$route.name == 't.a.order.index'){
                  this.$store.dispatch(
                    "order/showModalAfterAction",
                    true
                  );
                }
              }else{
                this.$toastr.w(
                  this.$t(addPage.data.message),
                  "<span class='t-icon icon-checkmark3'></span>" + this.$t("Error")
                );
                this.isDisabled = false;
              }
             
            } catch (error) {
              // this.$toastr.e(
              //   error,
              //   "<span class='t-icon icon-checkmark3'></span>" + this.$t("Error")
              // );
              // console.log('error', error.response.status);
              // this.isDisabled = false;
              // if (error.response.status === 403) {
              //   this.hasPermission = false;
              //   this.isLoadExceedLimit = false;
              // }
            }
          }
      });
    },
    closeModal(){
      this.$parent.isShowPagemodal = false;
    }
  },
  mounted() {
    this.$nextTick(async () => {
      await this.getIntegration();
    });
  },
  watch: {

  }
}
</script>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/ModalExceedLimitList.vue